import React, { PureComponent } from 'react';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import { CustomerFormValuesType } from 'Type/Account.type';

import './MyAccountSubscriptionFields.style';

/** @namespace PeggysagePwa/Component/MyAccountSubscriptionFields/Component */
export class MyAccountSubscriptionFieldsComponent extends PureComponent {
    static propTypes = {
        defaultValues: CustomerFormValuesType.isRequired
    };

    renderContent() {
        const { defaultValues } = this.props;

        return (
            <>
                { /* <div block="MyAccountSubscriptionFields" elem="Field">
                    <Field
                      type={ FIELD_TYPE.checkbox }
                      label={ __('Je souhaite m\'abonner à la newsletter') }
                      attr={ {
                          id: 'is_subscribed',
                          name: 'is_subscribed',
                          defaultChecked: defaultValues.is_subscribed ?? false
                      } }
                      mix={ { block: 'MyAccountSubscriptionFields', elem: 'Checkbox' } }
                    />
                </div> */ }
                <div block="MyAccountSubscriptionFields" elem="Field">
                    <p>
                        { __('I would like to receive tips from') }
                        { ' ' }
                        <strong>{ __('Peggy Sage') }</strong>
                    </p>
                    <div block="MyAccountSubscriptionFields" elem="Checkboxes" className="Field-Wrapper_checkboxes">
                        <Field
                          type={ FIELD_TYPE.checkbox }
                          label={ __('Via email') }
                          attr={ {
                              id: 'rgpd_offre_peggysage',
                              name: 'rgpd_offre_peggysage',
                              defaultChecked: defaultValues.rgpd_offre_peggysage ?? false
                          } }
                          mix={ { block: 'MyAccountSubscriptionFields', elem: 'Checkbox' } }
                        />
                        <Field
                          type={ FIELD_TYPE.checkbox }
                          label={ __('Via SMS') }
                          attr={ {
                              id: 'rgpd_offre_peggysage_sms',
                              name: 'rgpd_offre_peggysage_sms',
                              defaultChecked: defaultValues.rgpd_offre_peggysage_sms ?? false
                          } }
                          mix={ { block: 'MyAccountSubscriptionFields', elem: 'Checkbox' } }
                        />
                    </div>
                </div>
                { /* <div block="MyAccountSubscriptionFields" elem="Field">
                    <p>
                        { __('I would like to receive tips from') }
                        { ' ' }
                        <strong>{ __('Peggy Sage\'s partners') }</strong>
                    </p>
                    <div block="MyAccountSubscriptionFields" elem="Checkboxes" className="Field-Wrapper_checkboxes">
                        <Field
                          type={ FIELD_TYPE.checkbox }
                          label={ __('Via email') }
                          attr={ {
                              id: 'rgpd_offre_partenaire',
                              name: 'rgpd_offre_partenaire',
                              defaultChecked: defaultValues.rgpd_offre_partenaire ?? false
                          } }
                          mix={ { block: 'MyAccountSubscriptionFields', elem: 'Checkbox' } }
                        />
                        <Field
                          type={ FIELD_TYPE.checkbox }
                          label={ __('Via SMS') }
                          attr={ {
                              id: 'rgpd_offre_partenaire_sms',
                              name: 'rgpd_offre_partenaire_sms',
                              defaultChecked: defaultValues.rgpd_offre_partenaire_sms ?? false
                          } }
                          mix={ { block: 'MyAccountSubscriptionFields', elem: 'Checkbox' } }
                        />
                    </div>
                </div> */ }
            </>
        );
    }

    render() {
        return (
            <div block="MyAccountSubscriptionFields">
                { this.renderContent() }
            </div>
        );
    }
}

export default MyAccountSubscriptionFieldsComponent;
